/* Rising Sun FPV: Podium chat button on phones.
   Podium's phone widget (the round button with "Call us" and "Text us") starts open on every page,
   does not remember being closed, and gives the site no way to close it.
   This closes it as it loads, so every page starts with just the round button.
   Tapping the button still opens the menu as normal.
   The matching CSS is in layout/theme.liquid (search for rs-pod-wait). */
(function () {
  'use strict';

  var html = document.documentElement;
  var WAIT = 'rs-pod-wait'; // while this class is on <html>, the phone widget is kept invisible
  var started = Date.now();
  var frameSeen = 0;
  var revealTimer = null;

  function reveal(delay) {
    clearTimeout(revealTimer);
    revealTimer = window.setTimeout(function () { html.classList.remove(WAIT); }, delay || 0);
  }

  function bubbleIn(frame) {
    try {
      var doc = frame.contentDocument;
      return doc ? doc.querySelector('.ContactBubble__Bubble') : null;
    } catch (e) {
      return null;
    }
  }

  function isOpen(bubble) {
    return String(bubble.className).indexOf('ContactBubble__Bubble--opened') > -1;
  }

  // Close the menu if it is open, and keep an eye on it for a few seconds in case Podium opens it late.
  // Stops as soon as the visitor touches the widget, so it never fights a real tap.
  function guard(frame) {
    var touched = false;
    var lastClick = 0;
    var until = Date.now() + 3000;
    function mark(e) { if (e.isTrusted) touched = true; }
    try {
      ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function (type) {
        frame.contentDocument.addEventListener(type, mark, true);
      });
    } catch (e) {}

    (function tick() {
      if (touched) { reveal(0); return; }
      var bubble = bubbleIn(frame);
      if (bubble && isOpen(bubble)) {
        if (Date.now() - lastClick > 600) {
          lastClick = Date.now();
          bubble.click();
          reveal(350); // let the menu finish folding away before showing the button
        }
      } else if (!lastClick) {
        reveal(0);
      }
      if (Date.now() < until) window.setTimeout(tick, 200);
    })();
  }

  function find() {
    var frame = document.getElementById('podium-call-now-bubble');
    if (frame) {
      if (!frameSeen) frameSeen = Date.now();
      if (bubbleIn(frame)) { guard(frame); return; }
      // The widget is there but not in the shape we expect: show it as Podium made it.
      if (Date.now() - frameSeen > 3000) { reveal(0); return; }
    } else if (document.getElementById('podium-bubble') || Date.now() - started > 30000) {
      // The desktop widget loaded instead, or Podium never arrived: nothing to do.
      reveal(0);
      return;
    }
    window.setTimeout(find, 250);
  }

  html.classList.add(WAIT);
  find();
})();